const schemeAccent = [
  '#7FC97F',
  '#BEAED4',
  '#FDC086',
  '#FFFF99',
  '#386CB0',
  '#F0027F',
  '#BF5B17',
  '#afaeae',
  '#1B9E77',
  '#D95F02',
  '#7570B3',
  '#E7298A',
  '#66A61E',
  '#E6AB02',
  '#A6761D',
  '#666666',
  '#8DA0CB',
  '#E78AC3',
  '#A6D854',
  '#FFD92F',
  '#E5C494',
  '#B3B3B3',
  '#A1D99B',
  '#9ECAE1',
  '#FBB4AE',
];

const schemeDark2 = [
  '#1B9E77',
  '#D95F02',
  '#7570B3',
  '#E7298A',
  '#66A61E',
  '#E6AB02',
  '#A6761D',
  '#666666',
  '#8DD3C7',
  '#FFFFB3',
  '#BEBADA',
  '#FB8072',
  '#80B1D3',
  '#FDB462',
  '#B3DE69',
  '#FCCDE5',
  '#D9D9D9',
  '#BC80BD',
  '#CCEBC5',
  '#FFED6F',
  '#A6CEE3',
  '#1F78B4',
  '#B2DF8A',
  '#33A02C',
  '#FB9A99',
];

const schemeSet1 = [
  '#E41A1C',
  '#377EB8',
  '#4DAF4A',
  '#984EA3',
  '#FF7F00',
  '#FFFF33',
  '#A65628',
  '#F781BF',
  '#999999',
  '#66C2A5',
  '#FC8D62',
  '#8DA0CB',
  '#E78AC3',
  '#A6D854',
  '#FFD92F',
  '#E5C494',
  '#B3B3B3',
  '#FBB4AE',
  '#B3CDE3',
  '#CCEBC5',
  '#DECBE4',
  '#FED9A6',
  '#FFFFCC',
  '#E5D8BD',
  '#FDDAEC',
];

const schemeSet2 = [
  '#66C2A5',
  '#FC8D62',
  '#8DA0CB',
  '#E78AC3',
  '#A6D854',
  '#FFD92F',
  '#E5C494',
  '#B3B3B3',
  '#A1D99B',
  '#3f9abf',
  '#FBB4AE',
  '#B2E2E2',
  '#CCEBC5',
  '#DECBE4',
  '#FED9A6',
  '#FFFFCC',
  '#E5D8BD',
  '#FDDAEC',
  '#F2F2F2',
  '#CBC9E2',
  '#9E9AC8',
  '#6A51A3',
  '#54278F',
  '#756BB1',
  '#9ECAE1',
];

const schemeSet3 = [
  '#8DD3C7',
  '#FFFFB3',
  '#BEBADA',
  '#FB8072',
  '#80B1D3',
  '#FDB462',
  '#B3DE69',
  '#FCCDE5',
  '#D9D9D9',
  '#BC80BD',
  '#CCEBC5',
  '#FFED6F',
  '#A6CEE3',
  '#1F78B4',
  '#B2DF8A',
  '#33A02C',
  '#FB9A99',
  '#E31A1C',
  '#FDBF6F',
  '#FF7F00',
  '#CAB2D6',
  '#6A3D9A',
  '#FFFF99',
  '#B15928',
  '#FFD92F',
];

const schemePaired = [
  '#A6CEE3',
  '#1F78B4',
  '#B2DF8A',
  '#33A02C',
  '#FB9A99',
  '#E31A1C',
  '#FDBF6F',
  '#FF7F00',
  '#CAB2D6',
  '#6A3D9A',
  '#FFFF99',
  '#B15928',
  '#8DD3C7',
  '#FFFFB3',
  '#BEBADA',
  '#FB8072',
  '#80B1D3',
  '#FDB462',
  '#B3DE69',
  '#FCCDE5',
  '#D9D9D9',
  '#BC80BD',
  '#CCEBC5',
  '#FFED6F',
  '#999999',
];

const schemePastel1 = [
  '#FBB4AE',
  '#B3CDE3',
  '#CCEBC5',
  '#DECBE4',
  '#FED9A6',
  '#FFFFCC',
  '#E5D8BD',
  '#FDDAEC',
  '#F2F2F2',
  '#CBC9E2',
  '#9ECAE1',
  '#A1D99B',
  '#C7E9C0',
  '#D9F0A3',
  '#FEE391',
  '#FBB4B9',
  '#FCCEDE',
  '#E6F5C9',
  '#FFF2AE',
  '#F1E2CC',
  '#F6E8C3',
  '#E2F0CB',
  '#E5C494',
  '#F6BDC0',
  '#C9C9FF',
];

const schemePastel2 = [
  '#B3E2CD',
  '#FDCDAC',
  '#CBD5E8',
  '#F4CAE4',
  '#a9a3a3',
  '#FFF2AE',
  '#F1E2CC',
  '#CCCCCC',
  '#CCEBC5',
  '#DECBE4',
  '#FED9A6',
  '#FFFFCC',
  '#E5D8BD',
  '#FDDAEC',
  '#F2F2F2',
  '#CBC9E2',
  '#FBB4AE',
  '#B3CDE3',
  '#9ECAE1',
  '#A1D99B',
  '#C7E9C0',
  '#D9F0A3',
  '#FEE391',
  '#E6F5C9',
  '#FFD92F',
];

export const COLOR_SCHEMES = [
  { name: 'Accent', values: schemeAccent },
  { name: 'Dark', values: schemeDark2 },
  { name: 'Set 1', values: schemeSet1 },
  { name: 'Set 2', values: schemeSet2 },
  { name: 'Set 3', values: schemeSet3 },
  { name: 'Paired', values: schemePaired },
  { name: 'Pastel 1', values: schemePastel1 },
  { name: 'Pastel 2', values: schemePastel2 },
];

export const COLOR_SCALES = [
  { name: 'green-orange', values: ['#0FFD93', '#FC8D62'] },
  { name: 'orange-green', values: ['#FC8D62', '#0FFD93'] },
  { name: 'purple-yellow', values: ['#BC20FF', '#EDFF48'] },
  { name: 'yellow-purple', values: ['#EDFF48', '#BC20FF'] },
  { name: 'green', values: ['#BFFF0E', '#1194FF'] },
  { name: 'green-reverted', values: ['#1194FF', '#BFFF0E'] },
  { name: 'orange-blue', values: ['#FFC30E', '#2D11FF'] },
  { name: 'blue-orange', values: ['#2D11FF', '#FFC30E'] },
  { name: 'red', values: ['#EFEFEF', '#FF2920'] },
  { name: 'red-reverted', values: ['#FF2920', '#EFEFEF'] },
  { name: 'blue', values: ['#1452FF', '#F9F9F9'] },
  { name: 'blue-reverted', values: ['#F9F9F9', '#1452FF'] },
];

// Palette used to auto-assign distinct colors to new map layers. Matches the
// in-app color picker presets (color-picker.tsx) minus white/black, which are
// unusable as default map-layer fills. Teal is first so single-layer maps
// keep the pre-GEO-573 default.
export const DEFAULT_LAYER_COLOR_PALETTE = [
  '#2DD4BF', // teal
  '#3B82F6', // blue
  '#F43F5E', // rose
  '#84CC16', // lime
  '#8B5CF6', // violet
  '#FACC15', // yellow
  '#EC4899', // pink
  '#10B981', // emerald
  '#6366F1', // indigo
  '#D946EF', // fuchsia
  '#4ADE80', // green
  '#60A5FA', // light blue
] as const;

/**
 * Pick `count` colors from `palette` that are distinct from `usedColors`.
 * When the palette is exhausted, picks the least-used palette color (palette
 * order breaks ties), so duplicates build up evenly instead of piling onto
 * the first entry. Non-palette entries in `usedColors` are ignored.
 */
export function pickDistinctLayerColors(
  count: number,
  usedColors: string[],
  palette: readonly string[] = DEFAULT_LAYER_COLOR_PALETTE
): string[] {
  const counts = new Map<string, number>();
  for (const color of palette) counts.set(color.toLowerCase(), 0);
  for (const used of usedColors) {
    const key = used.toLowerCase();
    const c = counts.get(key);
    if (c !== undefined) counts.set(key, c + 1);
  }

  const picked: string[] = [];
  for (let i = 0; i < count; i++) {
    let bestColor = palette[0];
    let bestCount = counts.get(bestColor.toLowerCase()) ?? 0;
    for (const color of palette) {
      const c = counts.get(color.toLowerCase()) ?? 0;
      if (c < bestCount) {
        bestColor = color;
        bestCount = c;
      }
    }
    picked.push(bestColor);
    counts.set(bestColor.toLowerCase(), bestCount + 1);
  }
  return picked;
}

// Helper to convert hex to RGB
function hexToRgb(hex: string): { r: number; g: number; b: number } {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : { r: 0, g: 0, b: 0 };
}

// Helper to convert RGB to hex
function rgbToHex(r: number, g: number, b: number): string {
  return '#' + [r, g, b].map(x => Math.round(x).toString(16).padStart(2, '0')).join('');
}

/**
 * Generate N evenly spaced colors between two colors.
 * First color is always startColor, last is always endColor.
 */
export function generateGradientColors(
  startColor: string,
  endColor: string,
  steps: number
): string[] {
  if (steps <= 0) return [];
  if (steps === 1) return [startColor];

  const start = hexToRgb(startColor);
  const end = hexToRgb(endColor);
  const colors: string[] = [];

  for (let i = 0; i < steps; i++) {
    const t = i / (steps - 1);
    colors.push(
      rgbToHex(
        start.r + (end.r - start.r) * t,
        start.g + (end.g - start.g) * t,
        start.b + (end.b - start.b) * t
      )
    );
  }
  return colors;
}

function rgbToHsl(r: number, g: number, b: number): { h: number; s: number; l: number } {
  const rn = r / 255;
  const gn = g / 255;
  const bn = b / 255;
  const max = Math.max(rn, gn, bn);
  const min = Math.min(rn, gn, bn);
  const l = (max + min) / 2;
  if (max === min) return { h: 0, s: 0, l };

  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  let h: number;
  switch (max) {
    case rn:
      h = ((gn - bn) / d + (gn < bn ? 6 : 0)) / 6;
      break;
    case gn:
      h = ((bn - rn) / d + 2) / 6;
      break;
    default:
      h = ((rn - gn) / d + 4) / 6;
  }
  return { h: h * 360, s, l };
}

function hslToRgb(h: number, s: number, l: number): { r: number; g: number; b: number } {
  const hn = (((h % 360) + 360) % 360) / 360;
  if (s === 0) {
    const v = l * 255;
    return { r: v, g: v, b: v };
  }
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const channel = (t: number): number => {
    let tn = t;
    if (tn < 0) tn += 1;
    if (tn > 1) tn -= 1;
    if (tn < 1 / 6) return p + (q - p) * 6 * tn;
    if (tn < 1 / 2) return q;
    if (tn < 2 / 3) return p + (q - p) * (2 / 3 - tn) * 6;
    return p;
  };
  return {
    r: channel(hn + 1 / 3) * 255,
    g: channel(hn) * 255,
    b: channel(hn - 1 / 3) * 255,
  };
}

/**
 * Variant for a category index that ran past the scheme's colors. Golden-angle
 * hue steps keyed on the index keep landing on fresh hues (a fixed table would
 * repeat once exhausted); saturation and lightness ride out-of-phase walks
 * mapped into a mid band rather than clamped, since clamping collapses distinct
 * inputs onto the same color. The saturation floor also keeps grey scheme
 * entries apart -- with s == 0 a hue shift alone changes nothing.
 */
function categoryVariantHsl(
  base: { h: number; s: number; l: number },
  index: number
): { h: number; s: number; l: number } {
  const GOLDEN_ANGLE = 137.508;
  const hue = base.h + index * GOLDEN_ANGLE;
  const saturation = 0.45 + 0.4 * ((((index * 0.211) % 1) + 1) % 1);
  const lightness = 0.3 + 0.4 * ((((index * 0.377) % 1) + 1) % 1);
  return { h: hue, s: saturation, l: lightness };
}

/**
 * Color for the Nth category of a categorical scheme.
 *
 * Schemes ship a fixed number of colors (25), but the render cap allows far
 * more categories, so a plain `index % length` made every 26th category
 * identical to the first. This derives a shifted variant for each further pass
 * instead, keeping the first pass byte-identical to the authored scheme.
 * Deterministic: the legend, the paint expressions, and the customization panel
 * all resolve the same index to the same color.
 */
export function categoryColorAt(schemeValues: readonly string[], index: number): string {
  if (schemeValues.length === 0) return '#000000';
  const base = schemeValues[index % schemeValues.length];
  const cycle = Math.floor(index / schemeValues.length);
  if (cycle === 0) return base;

  const { r, g, b } = hexToRgb(base);
  const variant = categoryVariantHsl(rgbToHsl(r, g, b), index);
  const shifted = hslToRgb(variant.h, variant.s, variant.l);
  return rgbToHex(shifted.r, shifted.g, shifted.b).toUpperCase();
}

/**
 * Check if a scheme name is a gradation scheme (from COLOR_SCALES).
 */
export function isGradationScheme(schemeName: string | null | undefined): boolean {
  if (!schemeName) return false;
  return COLOR_SCALES.some(scale => scale.name === schemeName);
}

/**
 * Extract a sortable number from a category value.
 * Handles:
 * - Plain numbers: "123" -> 123
 * - Numbers with commas: "1,234" -> 1234
 * - Range formats: "501-3,300" -> 501 (uses lower bound)
 * - Prefix operators: "<=500" -> 500, ">100,000" -> 100000
 * Returns null if no number can be extracted.
 */
function extractSortableNumber(value: string): number | null {
  // Handle non-string values defensively
  if (typeof value !== 'string') {
    // If it's already a number, return it
    if (typeof value === 'number' && isFinite(value)) {
      return value;
    }
    // Convert to string for other types
    value = String(value);
  }

  // Remove commas from the value for parsing
  const cleaned = value.replace(/,/g, '');

  // Try to extract number from prefix operators like <=, >=, <, >
  const prefixMatch = cleaned.match(/^[<>=]+\s*(-?\d+\.?\d*)/);
  if (prefixMatch) {
    const num = parseFloat(prefixMatch[1]);
    if (!isNaN(num) && isFinite(num)) {
      // For ">" prefix, add a small amount to sort after the equal value
      // For "<=" prefix, use the number as-is
      if (cleaned.startsWith('>') && !cleaned.startsWith('>=')) {
        return num + 0.0001;
      }
      return num;
    }
  }

  // Try to extract first number from range format like "501-3300"
  const rangeMatch = cleaned.match(/(-?\d+\.?\d*)/);
  if (rangeMatch) {
    const num = parseFloat(rangeMatch[1]);
    if (!isNaN(num) && isFinite(num)) {
      return num;
    }
  }

  return null;
}

/**
 * Sort category values: numbers first (sorted numerically), then strings (sorted alphabetically).
 * Handles range formats like "501-3,300" and prefix operators like "<=500".
 */
export function sortCategoryValues(values: Set<string> | string[]): string[] {
  const arr = Array.isArray(values) ? values : Array.from(values);
  const numbers: { value: string; num: number }[] = [];
  const strings: string[] = [];

  for (const v of arr) {
    const num = extractSortableNumber(v);
    if (num !== null) {
      numbers.push({ value: v, num });
    } else {
      strings.push(v);
    }
  }

  numbers.sort((a, b) => a.num - b.num);
  strings.sort((a, b) => a.localeCompare(b));

  return [...numbers.map(n => n.value), ...strings];
}

/**
 * That's probably not the best way to do this, but it's a quick solution to get a color for an entity based on its id.
 *
 * This file is referenced in tailwind.config.ts in config.content so that the colors actually work.
 * If you move it to a different file, you will need to add it to the tailwind.config.ts config.content.
 *
 * Details: https://v3.tailwindcss.com/docs/content-configuration
 */

/**
 * Computes the indicator background and representative color for a layer's color logic.
 * Used by both the main app (useLayerColors) and embeds (getEmbedLegendData).
 */
export function computeColorLogicBackground(
  colorLogicEnabled: boolean,
  colorLogicType: string,
  colorLogicScheme: string | null,
  legendColors: Record<string, string>,
  baseColor: string
): { mainColor: string; colorLogicBackground?: string } {
  if (!colorLogicEnabled) return { mainColor: baseColor };

  if (colorLogicType === 'category') {
    const categoryColors = Object.values(legendColors);
    if (categoryColors.length > 0) {
      const colorsForGradient = categoryColors.slice(0, 4);
      const n = colorsForGradient.length;
      const stops: string[] = [];
      for (let i = 0; i < n; i++) {
        const start = Math.round((i / n) * 100);
        const end = Math.round(((i + 1) / n) * 100);
        stops.push(`${colorsForGradient[i]} ${start}%`, `${colorsForGradient[i]} ${end}%`);
      }
      return {
        mainColor: colorsForGradient[0],
        colorLogicBackground: `linear-gradient(90deg, ${stops.join(', ')})`,
      };
    }
  } else if (colorLogicType === 'value') {
    const scale = COLOR_SCALES.find(s => s.name === colorLogicScheme)?.values;
    if (scale && scale.length > 0) {
      return {
        mainColor: scale[Math.floor(scale.length / 2)],
        colorLogicBackground: `linear-gradient(90deg, ${scale.join(', ')})`,
      };
    }
  }

  return { mainColor: baseColor };
}

export const assignColorToId = (id: string) => {
  const colors = [
    'bg-amber-800 !text-amber-200 *:!text-amber-200',
    'bg-lime-800 !text-lime-200 *:!text-lime-200',
    'bg-green-800 !text-green-200 *:!text-green-200',
    'bg-rose-800 !text-rose-200 *:!text-rose-200',
    'bg-indigo-800 !text-indigo-200 *:!text-indigo-200',
    'bg-purple-800 !text-purple-200 *:!text-purple-200',
    'bg-brand-primary !text-white *:!text-white',
    'bg-fuchsia-800 !text-fuchsia-200 *:!text-fuchsia-200',
  ];

  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash += id.charCodeAt(i);
  }

  return colors[hash % colors.length];
};
